import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBRow,
} from "mdbreact";
import React from "react";
import Stamp from "../../elements/stamp/Stamp";
import classes from "./StampCard.module.scss";

/**
 * スタンプカードプロパティ
 */
type StampCardProps = {
  /** タイトル */
  title: string;
  /** スタンプ */
  stamps: {
    /** ID */
    id: string;
    /** スタンプ画像URL */
    image: string;
    /** カテゴリ名 */
    categoryName: string;
    /** スタンプ確認済み状態 */
    isChecked: boolean;
    /** スタンプ達成状態 */
    isAchieve: boolean;
    /** 取り外し可能か */
    isRemovable?: boolean;
  }[];
  /** カスタマイズ可能か */
  isCustomizable: boolean;
  /** スタンプ変更可能か */
  isReplaceable?: boolean;
  /** カスタマイズボタンクリックイベント */
  onCustomizeClick?: () => void;
  /** 取り外しクリックイベント */
  onRemoveClick?: (id: string) => void;
  /** スタンプ変更クリックイベント */
  onReplaceClick?: () => void;
  /** スタンプクリック時の処理 */
  onStampClick?: (is: string) => void;
};

/**
 * スタンプカードコンポーネント
 * @param props スタンプカードプロパティ
 */
const StampCard: React.FC<StampCardProps> = (props) => {
  return (
    <React.Fragment>
      <MDBCard className={`${classes.stampCard} mt-2 mb-2`}>
        <MDBCardHeader className={`${classes.stampCardHeader} py-2`}>
          {props.title}
        </MDBCardHeader>
        <MDBCardBody className={`${classes.stampCardBody} py-2`}>
          <MDBRow className={classes.stampContainer}>
            {props.stamps.map((stamp, i) => {
              return (
                <MDBCol size="3" className="p-1 text-center" key={i}>
                  <Stamp
                    id={stamp.id}
                    image={stamp.image}
                    isChecked={stamp.isChecked}
                    isAchieve={stamp.isAchieve}
                    isRemoveable={stamp.id ? stamp.isRemovable : false}
                    isBlank={!stamp.id}
                    onRemoveClick={stamp.id ? props.onRemoveClick : undefined}
                    onClick={props.onStampClick}
                  ></Stamp>
                  <div className={`mt-2 ${classes.categoryName}`}>
                    {stamp.categoryName}
                  </div>
                </MDBCol>
              );
            })}
          </MDBRow>
          {props.isReplaceable ? (
            <div className={`${classes.replace} text-center`}>
              <MDBBtn
                className={`${classes.replaceButton} py-2`}
                onClick={props.onReplaceClick}
              >
                ショップを変更する
              </MDBBtn>
            </div>
          ) : null}
        </MDBCardBody>
      </MDBCard>

      {props.isCustomizable ? (
        <div className={`${classes.customize} text-center`}>
          <MDBBtn
            className={`${classes.customizeButton} py-2`}
            color="pink"
            onClick={props.onCustomizeClick}
          >
            ショップを自分で選ぶ
          </MDBBtn>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default StampCard;
